import t from "./_getNative.js";
import a from "./_root.js";
var o = t(a, "DataView");
const i = o;
export {
  i as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/lodash-es@4.17.21/~/lodash-es/_DataView.js
// module id = 1408
// module chunks = 41